import { Layout } from '@msanvarov/core-components';
import { useEffect, useState } from 'react';
import ShiningStar from '../../../../../../../libs/core-components/src/lib/layout/ShiningStar';
import ShootingStar from '../../../../../../../libs/core-components/src/lib/layout/ShootingStar';

const ExpenseTrackerDownloadPage = () => {
  const [downloadCount, setDownloadCount] = useState(1547);

  const handleDownload = () => {
    // Increment download count
    setDownloadCount((prev) => prev + 1);

    // Create download link for the APK
    const link = document.createElement('a');
    link.href =
      'https://pub-2aa44672129d4998a879f5f3343eb364.r2.dev/ExpenseTracker_v1.0.0_release.apk'; // You'll need to place the APK file here
    link.download = 'ExpenseTracker-Latest.apk';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Layout wrapperClass="main-aboutpage" title="Expense Tracker - Download">
      <section className="contact-area">
        <div className="container">
          <div className="about-details" data-aos="zoom-in">
            <h1 className="section-heading" data-aos="fade-up">
              <img src="/assets/star-2.png" alt="Star" />
              Expense Tracker
              <img src="/assets/star-2.png" alt="Star" />
            </h1>

            <br />
          </div>

          <div className="main-app-container shadow-box" data-aos="zoom-in">
            <ShiningStar />
            <ShootingStar />

            {/* Header Section */}
            <div className="app-header">
              <div className="app-title-section">
                <h2>Expense Tracker</h2>
                <p className="app-tagline">
                  Split expenses with friends, track loans, and manage group
                  finances effortlessly!
                </p>
                <div className="app-badges">
                  <span className="badge version">v1.0.0</span>
                  <span className="badge size">111 MB</span>
                  <span className="badge platform">Android 7.0+</span>
                  <span className="badge developer">By Abhishek Panthee</span>
                </div>
              </div>
              <div className="app-preview-mini">
                <img
                  src="/assets/apps/expense-tracker-preview.png"
                  alt="App Preview"
                />
              </div>
            </div>

            {/* Main Content Grid */}
            <div className="content-grid">
              {/* Left Column - Features & Info */}
              <div className="left-column">
                {/* Security Badge */}
                <div className="security-highlight">
                  <div className="security-icon"><i className="iconoir-lock" /></div>
                  <div className="security-text">
                    <h4>100% Safe & Secure</h4>
                    <p>Scanned on August 18, 2025 - No malware detected</p>
                    <a
                      href="/apps/expense-tracker/security"
                      target="_blank"
                      rel="noopener"
                    >
                      View Security Report →
                    </a>
                  </div>
                </div>

                {/* Key Features */}
                <div className="features-section">
                  <h3><i className="iconoir-sparks" /> What Makes This App Special?</h3>
                  <div className="features-grid">
                    <div className="feature-card">
                      <div className="feature-icon"><i className="iconoir-home-simple" /></div>
                      <h4>Room-Based Organization</h4>
                      <p>
                        Create rooms for different groups - roommates, friends,
                        travel buddies
                      </p>
                    </div>
                    <div className="feature-card">
                      <div className="feature-icon"><i className="iconoir-hand-cash" /></div>
                      <h4>Smart Expense Splitting</h4>
                      <p>
                        Add shared expenses and personal loans with automatic
                        calculations
                      </p>
                    </div>
                    <div className="feature-card">
                      <div className="feature-icon"><i className="iconoir-refresh-double" /></div>
                      <h4>Real-Time Sync</h4>
                      <p>
                        Works online and offline with automatic syncing when
                        connected
                      </p>
                    </div>
                    <div className="feature-card">
                      <div className="feature-icon"><i className="iconoir-graph-up" /></div>
                      <h4>Clear Balance Overview</h4>
                      <p>See exactly who owes what with color-coded balances</p>
                    </div>
                  </div>
                </div>

                {/* Perfect For Section */}
                <div className="perfect-for-section">
                  <h3>Perfect For</h3>
                  <div className="use-cases">
                    <span className="use-case-tag">Roommates</span>
                    <span className="use-case-tag">Friends</span>
                    <span className="use-case-tag">Travel Groups</span>
                    <span className="use-case-tag">Couples</span>
                    <span className="use-case-tag">Students</span>
                  </div>
                </div>

                {/* Stats */}
                <div className="stats-section">
                  <h3><i className="iconoir-graph-up" /> Download Statistics</h3>
                  <div className="stats-row">
                    <div className="stat">
                      <div className="stat-number">
                        {downloadCount.toLocaleString()}
                      </div>
                      <div className="stat-label">Downloads</div>
                    </div>
                    <div className="stat">
                      <div className="stat-number">4.8<i className="iconoir-star" /></div>
                      <div className="stat-label">Rating</div>
                    </div>
                    <div className="stat">
                      <div className="stat-number">156</div>
                      <div className="stat-label">Reviews</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column - Download Section */}
              <div className="right-column">
                <div className="download-card">
                  <div className="download-header">
                    <h3><i className="iconoir-rocket" /> Ready to Download?</h3>
                    <p>
                      Get the latest version and start managing your group
                      finances today!
                    </p>
                  </div>

                  <button
                    className="download-btn-large"
                    onClick={handleDownload}
                  >
                    <i className="iconoir-download" />
                    <span>Download APK</span>
                    <div className="download-size">111 MB</div>
                  </button>

                  <div className="release-info">
                    <div className="info-row">
                      <span className="label">Release Date:</span>
                      <span className="value">August 18, 2025</span>
                    </div>
                    <div className="info-row">
                      <span className="label">Version:</span>
                      <span className="value">1.0.0 (Latest)</span>
                    </div>
                    <div className="info-row">
                      <span className="label">Requirements:</span>
                      <span className="value">
                        Android 7.0+, 150 MB free space
                      </span>
                    </div>
                  </div>

                  <div className="whats-new">
                    <h4><i className="iconoir-bell-notification" /> What's New in v1.0.0</h4>
                    <ul>
                      <li>Initial release with room-based expense tracking</li>
                      <li>Smart loan management system</li>
                      <li>Real-time synchronization</li>
                      <li>Smart notifications</li>
                      <li>Bank-level security encryption</li>
                    </ul>
                  </div>

                  <div className="installation-steps">
                    <h4><i className="iconoir-smartphone" /> Quick Installation</h4>
                    <div className="steps">
                      <div className="step">
                        <span className="step-number">1</span>
                        <span>
                          Enable "Install from Unknown Sources" in Settings
                        </span>
                      </div>
                      <div className="step">
                        <span className="step-number">2</span>
                        <span>Download APK using the button above</span>
                      </div>
                      <div className="step">
                        <span className="step-number">3</span>
                        <span>Open downloaded file and install</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .main-app-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 40px;
          border-radius: 24px;
          position: relative;
          backdrop-filter: blur(15px);
          border: 1px solid rgba(255, 255, 255, 0.15);
          background: rgba(0, 0, 0, 0.3);
        }

        .app-header {
          display: flex;
          align-items: flex-start;
          gap: 32px;
          margin-bottom: 40px;
          padding-bottom: 32px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .app-icon-large img {
          width: 120px;
          height: 120px;
          border-radius: 24px;
          box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
          border: 2px solid rgba(255, 255, 255, 0.1);
        }

        .app-title-section {
          flex: 1;
        }

        .app-title-section h2 {
          font-size: 36px;
          font-weight: 800;
          margin: 0 0 12px 0;
          color: var(--primary_color);
          background: linear-gradient(135deg, var(--primary_color), #00ff88);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .app-tagline {
          font-size: 18px;
          color: var(--text_color);
          margin-bottom: 20px;
          line-height: 1.6;
          opacity: 0.9;
        }

        .app-badges {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
        }

        .badge {
          padding: 8px 16px;
          border-radius: 20px;
          font-size: 14px;
          font-weight: 600;
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .badge.version {
          background: rgba(0, 255, 0, 0.2);
          color: #00ff00;
          border-color: rgba(0, 255, 0, 0.3);
        }

        .badge.size {
          background: rgba(255, 165, 0, 0.2);
          color: #ffa500;
          border-color: rgba(255, 165, 0, 0.3);
        }

        .badge.platform {
          background: rgba(0, 150, 255, 0.2);
          color: #0096ff;
          border-color: rgba(0, 150, 255, 0.3);
        }

        .badge.developer {
          background: rgba(255, 255, 255, 0.1);
          color: var(--text_color);
        }

        .app-preview-mini {
          flex-shrink: 0;
        }

        .app-preview-mini img {
          width: 180px;
          border-radius: 16px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
        }

        .content-grid {
          display: grid;
          grid-template-columns: 1fr 400px;
          gap: 40px;
        }

        .left-column {
          display: flex;
          flex-direction: column;
          gap: 32px;
        }

        .security-highlight {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 20px;
          background: rgba(0, 255, 0, 0.1);
          border-radius: 16px;
          border: 1px solid rgba(0, 255, 0, 0.2);
        }

        .security-icon {
          font-size: 32px;
          flex-shrink: 0;
        }

        .security-text h4 {
          margin: 0 0 8px 0;
          color: #00ff00;
          font-weight: 700;
        }

        .security-text p {
          margin: 0 0 8px 0;
          font-size: 14px;
          opacity: 0.8;
        }

        .security-text a {
          color: var(--primary_color);
          text-decoration: none;
          font-weight: 600;
        }

        .features-section h3 {
          font-size: 24px;
          color: var(--primary_color);
          margin-bottom: 20px;
          font-weight: 700;
        }

        .features-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 20px;
        }

        .feature-card {
          padding: 24px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 16px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          transition: all 0.3s ease;
        }

        .feature-card:hover {
          transform: translateY(-4px);
          background: rgba(255, 255, 255, 0.08);
          border-color: rgba(255, 255, 255, 0.2);
        }

        .feature-icon {
          font-size: 32px;
          margin-bottom: 12px;
        }

        .feature-card h4 {
          margin: 0 0 12px 0;
          color: var(--primary_color);
          font-weight: 600;
          font-size: 16px;
        }

        .feature-card p {
          margin: 0;
          font-size: 14px;
          line-height: 1.5;
          opacity: 0.9;
        }

        .perfect-for-section h3 {
          font-size: 20px;
          color: var(--primary_color);
          margin-bottom: 16px;
          font-weight: 700;
        }

        .use-cases {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
        }

        .use-case-tag {
          padding: 10px 16px;
          background: rgba(0, 100, 255, 0.2);
          color: var(--primary_color);
          border-radius: 20px;
          font-size: 14px;
          font-weight: 500;
          border: 1px solid rgba(0, 100, 255, 0.3);
        }

        .stats-section h3 {
          font-size: 20px;
          color: var(--primary_color);
          margin-bottom: 16px;
          font-weight: 700;
        }

        .stats-row {
          display: flex;
          gap: 24px;
        }

        .stat {
          text-align: center;
          flex: 1;
        }

        .stat-number {
          font-size: 24px;
          font-weight: 800;
          color: var(--primary_color);
          margin-bottom: 4px;
        }

        .stat-label {
          font-size: 12px;
          opacity: 0.7;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .right-column {
          position: sticky;
          top: 20px;
          height: fit-content;
        }

        .download-card {
          padding: 32px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 20px;
          border: 1px solid rgba(255, 255, 255, 0.15);
          backdrop-filter: blur(10px);
        }

        .download-header {
          text-align: center;
          margin-bottom: 32px;
        }

        .download-header h3 {
          font-size: 24px;
          color: var(--primary_color);
          margin-bottom: 12px;
          font-weight: 700;
        }

        .download-header p {
          font-size: 16px;
          opacity: 0.9;
          line-height: 1.5;
        }

        .download-btn-large {
          width: 100%;
          padding: 20px;
          background: linear-gradient(135deg, var(--primary_color), #0066ff);
          color: white;
          border: none;
          border-radius: 16px;
          font-size: 18px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          margin-bottom: 24px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          box-shadow: 0 8px 32px rgba(0, 100, 255, 0.3);
          position: relative;
          overflow: hidden;
        }

        .download-btn-large:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 40px rgba(0, 100, 255, 0.4);
        }

        .download-btn-large i {
          font-size: 20px;
        }

        .download-size {
          position: absolute;
          top: 8px;
          right: 12px;
          font-size: 10px;
          background: rgba(255, 255, 255, 0.2);
          padding: 2px 8px;
          border-radius: 10px;
          font-weight: 500;
        }

        .release-info {
          margin-bottom: 24px;
        }

        .info-row {
          display: flex;
          justify-content: space-between;
          padding: 8px 0;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .info-row:last-child {
          border-bottom: none;
        }

        .label {
          font-weight: 600;
          color: var(--primary_color);
        }

        .value {
          opacity: 0.9;
        }

        .whats-new {
          margin-bottom: 24px;
          padding: 20px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 12px;
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .whats-new h4 {
          margin: 0 0 16px 0;
          color: var(--primary_color);
          font-weight: 600;
        }

        .whats-new ul {
          margin: 0;
          padding-left: 20px;
        }

        .whats-new li {
          margin-bottom: 8px;
          font-size: 14px;
          line-height: 1.4;
        }

        .installation-steps h4 {
          margin: 0 0 16px 0;
          color: var(--primary_color);
          font-weight: 600;
        }

        .steps {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .step {
          display: flex;
          align-items: center;
          gap: 12px;
          font-size: 14px;
        }

        .step-number {
          width: 24px;
          height: 24px;
          background: var(--primary_color);
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 12px;
          flex-shrink: 0;
        }

        @media (max-width: 1024px) {
          .content-grid {
            grid-template-columns: 1fr;
            gap: 32px;
          }

          .right-column {
            position: static;
          }

          .app-header {
            flex-direction: column;
            text-align: center;
            gap: 20px;
          }

          .features-grid {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 768px) {
          .main-app-container {
            padding: 24px;
          }

          .app-title-section h2 {
            font-size: 28px;
          }

          .app-badges {
            justify-content: center;
          }

          .stats-row {
            flex-direction: column;
            gap: 16px;
          }

          .use-cases {
            justify-content: center;
          }
        }
      `}</style>
    </Layout>
  );
};

export default ExpenseTrackerDownloadPage;
